import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import * as moment from 'moment'

Vue.use(Router)

const routerOptions = [
  {
    path: '/',
    name: 'home',
    component: 'Home',
  },
  {
    path: '/authen',
    name: 'authen',
    component: 'Authen',
  },
  {
    path: '/paymentMethods',
    name: 'paymentMethods',
    component: 'PaymentMethods',
  },
  {
    path: '/paymentInput/:method',
    name: 'paymentInput',
    component: 'PaymentInput',
  },
  {
    path: '/credit/:method',
    name: 'credit',
    component: 'Credit',
  },
  {
    path: '/qr/:method',
    name: 'qr',
    component: 'QR',
  },
  {
    path: '/scbeasy/:method',
    name: 'scbeasy',
    component: 'ScbEasy',
  },
  {
    path: '/paymentProcessing',
    name: 'paymentProcessing',
    component: 'PaymentProcessing',
  },
  {
    path: '/paymentSuccess',
    name: 'paymentSuccess',
    component: 'PaymentSuccess',
  },
  {
    path: '/paymentFail',
    name: 'paymentFail',
    component: 'PaymentFail',
  },
  {
    path: '/billRecieve',
    name: 'billRecieve',
    component: 'BillRecieve',
  },
  {
    path: '/kioskqr',
    name: 'kioskqr',
    component: 'KioskQR',
  },
  {
    path: '/paymentExpired',
    name: 'paymentExpired',
    component: 'PaymentExpired',
  },
]

const routes = routerOptions.map((route) => {
  return {
    path: route.path,
    name: route.name,
    component: () => import(`./views/${route.component}.vue`),
    meta: route.meta,
  }
})

const router = new Router({
  mode: 'history',
  routes: [
    ...routes,
    {
      path: '*',
      redirect: '/',
    },
  ],
})

router.beforeEach((to, from, next) => {
  let filter = ['paymentMethods', 'paymentInput', 'credit']
  if (filter.includes(to.name)) {
    store.commit('LOADING')
    store
      .dispatch('getBillDataStatus', to.query.linkcode)
      .then(() => {
        if (
          store.state.billDataStatus > 3 &&
          store.state.billData.total == store.state.billData.paid
        ) {
          next('/billRecieve/?linkcode=' + to.query.linkcode)
        } else {
          next()
        }
      })
      .then(() => {
        store.commit('LOAD_DONE')
      })
  } else {
    next()
  }
})

//Fix Expire After Paid
/* router.beforeEach((to, from, next) => {
  let filter = ['paymentMethods', 'paymentInput', 'credit']
  if (filter.includes(to.name)) {
    store.commit('LOADING')
    store
      .dispatch('getBillDataStatus', to.query.linkcode)
      .then(() => {
        console.log('router expire ' + store.state.expire)
        const exp = moment(store.state.expire).toDate()
        console.log('router ' + exp)
        if(exp.getTime() <= new Date().getTime()){
          console.log('router go Expire')
          next('/paymentExpired/?linkcode=' + to.query.linkcode)
        }
        else if (
          store.state.billDataStatus > 3 &&
          store.state.billData.total == store.state.billData.paid
        ) {
          console.log('router billDataStatus ' + store.state.billDataStatus)
          console.log('router total ' + store.state.billData.total)
          console.log('router paid ' + store.state.billData.paid)
          next('/billRecieve/?linkcode=' + to.query.linkcode)
        } else {
          console.log('router go Next')
          next()
        }
      })
      .then(() => {
        store.commit('LOAD_DONE')
      })
  } else {
    next()
  }
}) */

export default router
